import React, { useState, useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import LazyLoad from "react-lazyload";

function Header() {

  const [top, setTop] = useState(true);

  // detect whether user has scrolled the page down by 10px 
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);  

  return (
    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-white blur shadow-lg'}`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Site branding */}
          <div className="flex-shrink-0 mr-4">
            <Link to="/#timeline">
            <h5 className="bg-clip-text text-xl font-extrabold font-mono text-transparent bg-gradient-to-r from-blue-800 to-sky-400">
              ACM Winter
            </h5>
            <h5 className="bg-clip-text text-lg font-extrabold font-mono text-transparent bg-gradient-to-r from-blue-600 to-gray-700">
              3rd-14th Jan, 2022
            </h5>
            </Link>
          </div>

          {/* Site navigation */}
          <nav className="flex flex-grow">
            <ul className="flex flex-grow justify-end flex-wrap items-center">
              <li className="flex hidden md:block">
                <Link to="/#sponsors" className="font-medium text-gray-400 hover:text-gray-800 px-5 py-3 flex items-center transition duration-500 ease-in-out focus:outline-none" aria-label="ACM-Site">
                  Sponsors
                </Link>
              </li>
              <li className="flex hidden md:block">
                <Link to="/#timeline" className="font-medium text-gray-400 hover:text-gray-800 px-5 py-3 flex items-center transition duration-500 ease-in-out focus:outline-none" aria-label="ACM-Site">
                  Timeline
                </Link>
              </li>
              <li className="flex hidden md:block">
                <Link to="/#speakers" className="font-medium text-gray-400 hover:text-gray-800 px-5 py-3 flex items-center transition duration-500 ease-in-out focus:outline-none" aria-label="ACM-Site">
                  Speakers
                </Link>
              </li>
              <li className="flex hidden md:block">
                <Link to="/#organizers" className="font-medium text-gray-400 hover:text-gray-800 px-5 py-3 flex items-center transition duration-500 ease-in-out focus:outline-none" aria-label="ACM-Site">
                  Team
                </Link>
              </li>
              <li>
                <a href="https://india.acm.org/education" className="no-underline outline outline-4 hover:outline-2">
                  <span className="btn-sm bg-sky-400 rounded-full text-white hover:bg-gray-900
                                    hover:text-sky-400 hover:outline transition duration-700 ease-in-out shadow-xl">
                  <LazyLoad height="10">
                    <img className="mx-auto px-1" src={require('../images/favicon.png').default} width="35" height="10" alt="ACM India"/>
                  </LazyLoad>
                    ACM</span>
                </a>
              </li>
            </ul>

          </nav>

        </div>
      </div>
    </header>
  );
}

export default Header;
